module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("66dYF"))).then(() => parcelRequire('2KbAe'));